import React from 'react';
import { Grid } from '@mui/material';
import MarketplaceTabContent from './MarketplaceTabContent';
import FavouriteTabContent from './FavouriteTabContent';
import { useSparkSearchContext } from 'hooks/common/useSparkSearchContextV2';
import MemorySearchViewContent from '../MemorySearchViewContent';

function MemoryContent() {
  const { filter, handleItemTypeChange } = useSparkSearchContext();
  const { selectedItemType, ...restFilters } = filter || {};

  React.useEffect(() => {
    // if not filter is selected, default to all sparks
    if (!selectedItemType) {
      handleItemTypeChange('workspaceSources');
    }
  }, [handleItemTypeChange, selectedItemType]);

  const renderListView = Object.values(restFilters).some((filterValue) => {
    if (Array.isArray(filterValue)) {
      return filterValue.length;
    }
    if (filterValue === 'any') {
      return false;
    }
    return filterValue;
  });

  const renderContent = React.useMemo(() => {
    switch (true) {
      case !!renderListView || selectedItemType === 'mySources':
        return <MemorySearchViewContent />;
      case !!renderListView || selectedItemType === 'workspaceSources':
        return <MarketplaceTabContent />;
      case selectedItemType === 'myFavouritesSources':
        return <FavouriteTabContent />;
      default:
        return <></>;
    }
  }, [renderListView, selectedItemType]);

  return (
    <Grid container item flex={1}>
      <MemorySearchViewContent />
    </Grid>
  );
}

export default MemoryContent;
